<template>
    <div class="animated fadeIn dashboard-cuentas">

      <b-row>
        <b-col sm="6" lg="4">
          <app-indicador-ventas-total-clientes
            ref="indicadorVentasTotalClientes"
            :totalNegocio="true">
          </app-indicador-ventas-total-clientes>
        </b-col>

        <b-col sm="6" lg="4">
          <app-indicador-presupuestos-propuestos
            v-if="consultarPropuestas"
            ref="indicadorPresupuestosPropuestos">
          </app-indicador-presupuestos-propuestos>
        </b-col>

        <b-col sm="6" lg="4">
          <app-indicador-presupuestos-propuestos-confirmados
            v-if="consultarPropuestas"
            ref="indicadorPresupuestosPropuestosConfirmados">
          </app-indicador-presupuestos-propuestos-confirmados>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6" lg="4">
          <app-indicador-r-s-e
            ref="indicadorRSE">
          </app-indicador-r-s-e>
        </b-col>
      </b-row>

      <hr class="dashboard">      

      <ranking-ventas-clientes ref="rankingVentasClientes"></ranking-ventas-clientes>

      <hr class="dashboard">

      <ranking-presupuestos-clientes ref="rankingPresupuestosClientes"></ranking-presupuestos-clientes>

      <hr class="dashboard">

      <ranking-presupuestos-tipos ref="rankingPresupuestosTipos"></ranking-presupuestos-tipos>

      <hr class="dashboard">

      <ranking-presupuestos-tipos-importe ref="rankingPresupuestosTiposImporte"></ranking-presupuestos-tipos-importe>

      <hr class="dashboard">

      <ranking-rubros ref="rankingRubros"></ranking-rubros>

      <hr class="dashboard" v-if="consultarRentabilidadBruta">

      <b-row v-if="consultarRentabilidadBruta">
        <b-col sm="12" lg="12">
          <div class="dashboard-tabla-resultados">
            <div class="dashboard-tabla-resultados-header">
              <h4>Rentabilidad Bruta de Clientes</h4>
              <!-- <h4>Rentabilidad Bruta de Clientes <i id="actualizarCostos" @click="actualizarCostos" class="fa fa-refresh"></i></h4> -->
              <p class="description">El costo real incluye compras, remitos y viáticos. La órdenes de reembolsos no están incluidas.</p>
              <p class="description">Últimos 12 meses</p>
            </div>
            <div class="dashboard-tabla-resultados-data">
              <b-table hover
                  responsive="sm" 
                  class="registro"
                  :busy="tableBusy"
                  :items="resultadosRentabilidadBrutaClientes" 
                  :fields="resultadosRentabilidadBrutaClientesFields">
                <div slot="table-busy" class="text-center">
                  <b-spinner class="table-spinner" label="Spinning" />
                </div>
                <template v-slot:cell(pjeRentabilidadPromedio)="data">
                  {{ data.item.pjeRentabilidadPromedio | porcentaje }}
                </template>
                <template v-slot:cell(opciones)="data">
                  <template>
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                      <template slot="button-content">
                        <i class="fa fa-ellipsis-v"></i>
                      </template>
                      <b-dropdown-item @click.stop="exportarRentabilidadBrutaPresupuestos(data.item.clienteId)">
                        <i class="fa fa-file-excel-o"></i>Exportar Presupuestos</b-dropdown-item>
                      <b-dropdown-item @click.stop="exportarRentabilidadBrutaOrdenes(data.item.clienteId)">
                        <i class="fa fa-file-excel-o"></i>Exportar Órdenes</b-dropdown-item>
                    </b-dropdown>
                  </template>
                </template>
              </b-table>
            </div>
          </div>
        </b-col>
      </b-row>

      <hr class="dashboard">

      <b-row>
        <b-col sm="12" lg="12">
          <div class="dashboard-tabla-resultados">
            <div class="dashboard-tabla-resultados-header">
              <h4>Evolución semestral de clientes</h4>
              <p class="description">Monto neto total de ventas de cada semestre. Monto de reembolsos incluido.</p>
              <p class="description">Pje de incremento calculado desde la facturación del semestre anterior</p>
            </div>
            <div class="dashboard-tabla-resultados-data">
              <b-table hover
                  responsive="sm" 
                  class="registro"
                  :busy="tableBusy"
                  :items="resultadosEvolucionSemestralClientes" 
                  :fields="resultadosEvolucionSemestralClientesFields"
                  :current-page="paginaActualEvolucionSemestral"
                  :per-page="registrosPorPaginaEvolucionSemestral">
                <div slot="table-busy" class="text-center">
                  <b-spinner class="table-spinner" label="Spinning" />
                </div>
                <template v-slot:cell(montoNetoSemestreAnterior)="data">
                  {{ data.item.montoNetoSemestreAnterior | moneda }}
                </template>
                <template v-slot:cell(montoNetoSemestreActual)="data">
                  {{ data.item.montoNetoSemestreActual | moneda }}
                </template>
                <template v-slot:cell(pjeIncrementoVentas)="data">
                  {{ data.item.pjeIncrementoVentas | porcentaje }}
                </template>
              </b-table>
              <nav>
                <b-pagination size="sm" 
                  :total-rows="totalRegistrosEvolucionSemestral" 
                  :per-page="registrosPorPaginaEvolucionSemestral" 
                  v-model="paginaActualEvolucionSemestral" prev-text="Prev." next-text="Prox."/>
              </nav>
            </div>
          </div>
        </b-col>
      </b-row>

      <hr class="dashboard">

      <b-row class="evolucion-clientes">
        <b-col sm="12" lg="12">
          <div class="dashboard-chart">
            <h4>Evolución de Clientes (Grandes Clientes)</h4>
          </div>
          <line-evolucion-grandes-clientes 
            chartId="evolucion-grandes-clientes" 
            class="chart-wrapper"
            ref="evolucionGrandesClientes"
            :stepSize="parseInt(10)"
            :max="parseInt(100)">
          </line-evolucion-grandes-clientes>
        </b-col>
      </b-row>

      <b-row class="evolucion-clientes">
        <b-col sm="12" lg="12">
          <div class="dashboard-chart">
            <h4>Evolución de Clientes</h4>
          </div>
          <line-evolucion-clientes 
            chartId="evolucion-clientes" 
            class="chart-wrapper"
            ref="evolucionClientes"
            :stepSize="parseInt(10)"
            :max="parseInt(100)">
          </line-evolucion-clientes>
        </b-col>
      </b-row>

      <app-mensaje
        :modalMsj="modalMsj"
        :modalMensaje="modalMensaje"
        @okAction="okAction"
        @hiddenAction="hiddenAction">
      </app-mensaje>
    </div>
</template>

<script>
import Pie from '../charts/Pie';
import IndicadorVentasTotalClientes from './IndicadorVentasMixClientes';
import IndicadorRSE from './IndicadorRSE';
import IndicadorPresupuestosPropuestos from './IndicadorPresupuestosPropuestos';
import IndicadorPresupuestosPropuestosConfirmados from './IndicadorPresupuestosPropuestosConfirmados';
import RankingVentasClientes from './cuentas/RankingVentasCliente';
import RankingRubros from './cuentas/RankingRubros';
import RankingPresupuestosClientes from './cuentas/RankingPresupuestosCliente';
import RankingPresupuestosTipos from './cuentas/RankingTipoPresupuesto';
import RankingPresupuestosTiposImporte from './cuentas/RankingTipoPresupuestoImporte';
import LineEvolucionGrandesClientes from '../charts/LineEvolucionClientes.vue';
import LineEvolucionClientes from '../charts/LineEvolucionClientes.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  components: {
    Pie,
    appIndicadorVentasTotalClientes: IndicadorVentasTotalClientes,
    appIndicadorRSE: IndicadorRSE,
    appIndicadorPresupuestosPropuestos: IndicadorPresupuestosPropuestos,
    appIndicadorPresupuestosPropuestosConfirmados: IndicadorPresupuestosPropuestosConfirmados,
    RankingVentasClientes,
    RankingPresupuestosClientes,
    RankingPresupuestosTipos,
    RankingPresupuestosTiposImporte,
    RankingRubros,
    LineEvolucionGrandesClientes,
    LineEvolucionClientes,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],

data() {
    return {
      key: 0,
      tableBusy: false,

      resultadosRentabilidadBrutaClientes: [],
      resultadosRentabilidadBrutaClientesFields: [
        { key: 'cliente' },
        { 
          key: 'presupuestosInternos',
          label: 'Presupuestos',
          class: 'text-right'
        },
        { 
          key: 'ordenes',
          class: 'text-right'
        },
        { 
          key: 'pjeRentabilidadPromedio',
          label: 'Pje.Rentab.Promedio',
          class: 'text-right'
        },
        { 
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      resultadosEvolucionSemestralClientes: [],
      resultadosEvolucionSemestralClientesFields: [
        { key: 'cliente' },
        { 
          key: 'montoNetoSemestreAnterior',
          label: 'Sem.Anterior',
          class: 'text-right'
        },
        { 
          key: 'montoNetoSemestreActual',
          label: 'Sem.Actual',
          class: 'text-right'
        },
        { 
          key: 'pjeIncrementoVentas',
          label: 'Pje.Incremento',
          class: 'text-right'
        },
        // { 
        //   key: 'opciones',
        //   label: '',
        //   class: 'text-center'
        // },
      ],
      totalRegistrosEvolucionSemestral: 0,
      registrosPorPaginaEvolucionSemestral: 15,
      paginaActualEvolucionSemestral: 1,

      consultarRentabilidadBruta: false,
      consultarPropuestas: false
    }
  },
  created() {
    this.consultarRentabilidadBruta = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardCuentasRentabilidadBruta'));
    this.consultarPropuestas = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardCuentasConsultarPropuestas'));
  },
  methods: {
    getIndicadores() {
      this.$store.dispatch('resultadosVentas/getIndicadorVentasTotalMixClientes')
        .then(() => this.$refs.indicadorVentasTotalClientes.getIndicador());

      if (this.consultarPropuestas) {
        this.$refs.indicadorPresupuestosPropuestos.getIndicador();
        this.$refs.indicadorPresupuestosPropuestosConfirmados.getIndicador();
      }

      this.$refs.indicadorRSE.getIndicador();

      this.$store.dispatch('indicadoresCuentas/inicializar')
        .then(() => {
          this.$refs.rankingVentasClientes.getResultados();

          this.$refs.rankingPresupuestosClientes.getResultados();

          this.$refs.rankingPresupuestosTipos.getResultados();

          this.$refs.rankingPresupuestosTiposImporte.getResultados();

          this.$refs.rankingRubros.getResultados();

          if (this.consultarRentabilidadBruta) {
            this.$store.dispatch('indicadoresCuentas/getResultadosRentabilidadBrutaClientes')
              .then(() => {
                this.resultadosRentabilidadBrutaClientes = this.$store.getters['indicadoresCuentas/resultadosRentabilidadBrutaClientes'];
              });
          }

          this.$store.dispatch('indicadoresCuentas/getEvolucionClientes')
            .then(() => {
              let labels = this.$store.getters['indicadoresCuentas/evolucionClientesPeriodos'];

              /* Clientes */
              let data = this.$store.getters['indicadoresCuentas/evolucionPyMEClientes'];
              let evolucionPyMEClientesStepSize = parseInt(this.$store.getters['indicadoresCuentas/evolucionPyMEClientesStepSize']);
              let evolucionPyMEClientesMax = parseInt(this.$store.getters['indicadoresCuentas/evolucionPyMEClientesMax']);

              this.$refs.evolucionClientes.render(labels, data,
                evolucionPyMEClientesStepSize, evolucionPyMEClientesMax);
              
              /* Grandes Clientes */
              let dataGrandesClientes = this.$store.getters['indicadoresCuentas/evolucionGrandesClientes'];
              let evolucionGrandesClientesStepSize = parseInt(this.$store.getters['indicadoresCuentas/evolucionGrandesClientesStepSize']);
              let evolucionGrandesClientesMax = parseInt(this.$store.getters['indicadoresCuentas/evolucionGrandesClientesMax']);

              this.$refs.evolucionGrandesClientes.render(labels, dataGrandesClientes,
                evolucionGrandesClientesStepSize, evolucionGrandesClientesMax);
            });
      
          /* Evolución semestral de ventas por cliente */
          this.$store.dispatch('ventas/getRptEvolucionSemestralClientes')
            .then(() => {
              this.resultadosEvolucionSemestralClientes = this.$store.getters['ventas/rptVentas'];
              this.totalRegistrosEvolucionSemestral = this.resultadosEvolucionSemestralClientes.length;
            });
      });
    },
    getColor(item) {
      return item.color;
    },
    actualizarCostos() {
      this.showSpinner();
      this.$store.dispatch('indicadoresCuentas/actualizarCostosOrdenes')
        .then(() => {
            return this.$store.dispatch('indicadoresCuentas/getResultadosRentabilidadBrutaClientes')
        })
        .then(() => {
          this.resultadosRentabilidadBrutaClientes = this.$store.getters['indicadoresCuentas/resultadosRentabilidadBrutaClientes'];
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    exportarRentabilidadBrutaPresupuestos(clienteId) {
        this.showSpinner();
        this.$store.dispatch('indicadoresCuentas/getResultadosRentabilidadBrutaClientesPresupuestos', clienteId)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptPresupuestos = this.$store.getters['indicadoresCuentas/resultados'];

            if (rptPresupuestos) {
              if (rptPresupuestos.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              let title= 'Rentabilidad Bruta';
              let fileName = 'resumen-rentabilidad-bruta';
              let format = [
                { titulo: 'Cliente', nombre: 'cliente', formato: '' },
                { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
                { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
                { titulo: 'Accion', nombre: 'accion', formato: '' },
                { titulo: 'Total', nombre: 'cotizacionTotal', formato: '' },
                { titulo: 'Ordenes', nombre: 'ordenes', formato: '' },
                { titulo: 'Pje.Rentab.Promedio', nombre: 'pjeRentabilidadPromedio', formato: '' },
              ];

              this.exportXLS(title, fileName, rptPresupuestos, format);
              
            } else {
              this.showErrorMsj ('No hay datos para exportar.');
            }
          })
          .catch( error => this.showErrorMsj (error))
          .finally(() => this.hideSpinner());
    },
    exportarRentabilidadBrutaOrdenes(clienteId) {
        this.showSpinner();
        this.$store.dispatch('indicadoresCuentas/getResultadosRentabilidadBrutaClientesOrdenes', clienteId)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptPresupuestos = this.$store.getters['indicadoresCuentas/resultados'];

            if (rptPresupuestos) {
              if (rptPresupuestos.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              let title= 'Rentabilidad Bruta';
              let fileName = 'resumen-rentabilidad-bruta';
              let format = [
                { titulo: 'Cliente', nombre: 'cliente', formato: '' },
                { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
                { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
                { titulo: 'Accion', nombre: 'accion', formato: '' },
                { titulo: 'Nro.Orden', nombre: 'id', formato: '' },
                { titulo: 'Rubro', nombre: 'rubroTrabajo', formato: '' },
                { titulo: 'Título', nombre: 'titulo', formato: '' },
                { titulo: 'Cotización', nombre: 'cotizacion', formato: '' },
                { titulo: 'Costo', nombre: 'costo', formato: '' },
                { titulo: 'Pje.Rentabilidad', nombre: 'pjeRentabilidad', formato: '' },
              ];

              this.exportXLS(title, fileName, rptPresupuestos, format);
              
            } else {
              this.showErrorMsj ('No hay datos para exportar.');
            }
          })
          .catch( error => this.showErrorMsj (error))
          .finally(() => this.hideSpinner());
    }
  }
}
</script>

<style>
  /* .dashboard-cuentas {
    margin-bottom: 30px;
  } */
  .dashboard-cuentas .row {
    margin-bottom: 30px;
  }
  .dashboard-cuentas .dashboard-chart > div {
    position: relative;
    padding-left: 10%;
    padding-right: 10%;
    padding-bottom: 10%;    
    /* top: 20px;
    padding-left: 20px;
    padding-right: 20px; */
  }
  .dashboard-cuentas .dashboard-chart h4 {
    margin-bottom: 5px;
  }
  .dashboard-chart .description {
    font-size: 12px;
    font-style: italic;
  }

  .dashboard-cuentas table {
    position: relative;
    top: 20px;
  }
  .dashboard-cuentas table thead th {
    border-top: none;
  }
  .dashboard-cuentas table tbody tr td {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .dashboard-cuentas table .color-reference {
    display: inline-block;
    position: relative;
    /* margin-right: 5px; */
    width: 24px; 
    height: 12px; 
    top: 2px;
  }

  .dashboard-cuentas .evolucion-clientes .chart-wrapper {
    position: relative;
    height: 350px;
  }

  .dashboard-cuentas #actualizarCostos {
    font-size: 12px;
    margin-left: 5px;
    cursor: pointer;
  }
</style>


